import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <section className="footer-container">
      <div className="footer-social-links">
        <a href="mailto:admin@loonlog.ca" aria-label="Email">
          <i className="fa-solid fa-envelope"></i>
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61581387360529"
          aria-label="Facebook"
        >
          <i className="fa-brands fa-facebook"></i>
        </a>
        <a
          href="https://www.youtube.com/channel/UCTUDVeHnV_fkYCEpkqxAlGQ"
          aria-label="YouTube"
        >
          <i className="fa-brands fa-youtube"></i>
        </a>
        <a href="https://www.tiktok.com/@loonlog" aria-label="TikTok">
          <i className="fa-brands fa-tiktok"></i>
        </a>
        <a href="https://x.com/LoonLogSocial" aria-label="X (Twitter)">
          <i className="fa-brands fa-x-twitter"></i>
        </a>
        <a
          href="https://www.instagram.com/loonlog.social/?hl=en"
          aria-label="Instagram"
        >
          <i className="fa-brands fa-instagram"></i>
        </a>
        <a href="https://www.reddit.com/r/loonlog/" aria-label="Reddit">
          <i className="fa-brands fa-reddit"></i>
        </a>
      </div>

      <div className="footer-legal-info">
        <div className="footer-patent-text">
          🇨🇦 Patent Pending · CIPO 3292395.
        </div>
        <div>&copy; Copyright {currentYear} · LoonLog</div>
      </div>
    </section>
  );
};

export default Footer;
